
webpack.register(
    'layouts/pages/article/article',
    function() {
        return import('layouts/pages/article/article');
    },
    true
);